<script>
    import {createEventDispatcher} from 'svelte';
    import {sgettext} from '../../i18n.js';


    export let showIcon = false;
    export let item = {};
    export let selected = false;
    export let isChild = false;
    export let highlight = (text) => text;

    const dispatch = createEventDispatcher();

    $: showIcon = item.hasOwnProperty('icon') || item.hasOwnProperty('faIcon');

    function select(event) {
        dispatch('select', event);
    }

    function unselect(event) {
        dispatch('unselect', event);
    }

</script>

<style>
    .option-item {
        display: flex;
        display: flex;
        padding: 8px 12px;
        line-height: 18px;
        color: #454545;
        cursor: pointer;
    }

    .option-item:hover {
        background-color: #e9ecef;
        color: #454545;
    }

    .child {
        padding-left: 20px;
    }

    .icon {
        width: 64px;
        margin-right: 15px;
        font-size: 8px;
    }

    .option-item .label {
        flex: 1;
        color: #000 !important;
        justify-content: center;
    }

    .option-item img {
        width: 100%;
    }

    .selected {
        background-color: rgba(255, 214, 145, 0.3);
    }

    .fa-icon {
        margin-right: 15px;
    }

    .description {
        color: #454545;
    }

    .expired-option {
        border: 1px solid #f56e6e;
        padding: 4px;
    }
</style>

<div
        class="option-item"
        class:child={isChild}
        class:selected={Array.isArray(selected) ? false : selected == item.id}
        optionId={item.id}
        on:click={select}
        on:keyup|stopPropagation={(event) => event.key === 'Enter' ? select(event) : false}
        tabindex="0"
        data-testid="option-item"

>
    {#if showIcon}

        {#if item.icon}
                <div class="icon">
                    <img src={item.icon.url} alt={item.icon.name}/>
                </div>
        {:else if item.faIcon}
                <div class="fa-icon">
                    <i class="{item.faIcon.classes}" style="{item.faIcon.style}"/>
                </div>
        {/if}
    {/if}


    <div class="label">
        <div>
            <i class="fa fa-exclamation-circle text-danger" class:d-none={!item.expired} class:hidden={!item.expired} title="{sgettext('$$OPTION_EXPIRED$$')}"></i>
            {@html highlight(sgettext(item.name))}
        </div>
        {#if item.hasOwnProperty('description')}
            <div class="text-secondary description" style="white-space: pre-line">
                {item.description}
            </div>
        {/if}
    </div>
</div>
